import { createAction } from "@reduxjs/toolkit";
// The below will be used to revert to initial state in case of logout in different slices
// as we progressively migrate each slice to RTK
// each slice would have their own revert_all handler - extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
export const clearStoreAction = createAction<string>("CLEAR_RTK_STORE");
